import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { inc } from '../updaters';
export const useRecoilRequest = (request) => {
    const setRequestId = useSetRecoilState(request);
    return useCallback(() => {
        setRequestId(inc);
    }, [setRequestId]);
};
//# sourceMappingURL=useRecoilRequest.js.map